const PERMISSION_KEY= "company:bc_industry_group";
const PAGE_URL = {
    B_C_INDUSTRY_GROUP_PAGE: "/admin/company/bc-industry-group"
}

export {PERMISSION_KEY, PAGE_URL}

